<template>
	<div class="content background1">
		<div class="tableBox9">
			<div class="tableMes">
				<div class="table">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<el-tab-pane :label="$t('label_429')" name="first">
							<template>
								<tree :dataTree="treeData" @getDeviceMes="getDeviceMes"></tree>
							</template>
						</el-tab-pane>
						<el-tab-pane :label="$t('label_161')" name="second">
							<template>
								<tree :dataTree="treeData2" @getDeviceMes="getDeviceMes"></tree>
							</template>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<div class="tableBox10">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes">
						<p class="title"><span class="spot">{{deviceDetailMes.name}}</span>{{$t('label_1039')}}</p>
						<div class="chooseBox spaceBetween">
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText">
											<p>{{$t('label_593')}}</p>
										</div>
										<div class="select" style="width:350px">
											<el-input v-model="code" clearable></el-input>
										</div>
									</div>
								</div>
								<div>
									<div class="selectChoose" style="margin-left: 30px;">
										<div class="selectText">
											<p>{{$t('label_70')}}</p>
										</div>
										<div class="select" style="width:350px ">
											<el-date-picker v-model="Readytime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange"
											 :range-separator="$t('label_264')" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')">
											</el-date-picker>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox">
								<div>
									<div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
						</div>
						<!-- button -->
						<div class="spotMes2Box" style="height: calc(100% - 120px);">
<!--							<div class="buttonBox">-->
<!--								<div>-->
<!--									<div class="chooseButton searchButton" @click="exportClick" v-if="MenuRoleList.indexOf('61')>=0"><i class="el-icon-download"></i>导出</div>-->
<!--								</div>-->
<!--							</div>-->
							<div class="tableMin tableBorderBlack" style="height: calc(100% - 90px);">
								<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataList" highlight-current-row @current-change="handleCurrentChangeTreeTime"
								 border style="width: 100%;margin: 10px 0" height="100%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff','padding':'2px 0px'}"
								 :cell-style="cellStyle">

									<el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex" width="50">
									</el-table-column>
									<el-table-column prop="name" width="150" :label="$t('label_593')" align="left">
										<template slot-scope="scope">
											{{scope.row.superior}}<br>{{scope.row.tname}} {{scope.row.name}}<br>{{scope.row.code}}
										</template>
									</el-table-column>
									<el-table-column prop="useTime" :label="$t('label_1040')" align="center">
										<el-table-column prop="useTime" :label="$t('label_1041')" align="center">
										</el-table-column>
										<el-table-column prop="content" width="150" :label="$t('label_1042')" align="center">
											<template slot-scope="scope">
												{{scope.row.lifeTime-scope.row.useTime}}/{{scope.row.lifeTime}}
											</template>
										</el-table-column>
									</el-table-column>
									<el-table-column prop="content" :label="$t('label_1043')" align="center">
										<el-table-column prop="num" :label="$t('label_1044')" align="center">
										</el-table-column>
										<el-table-column prop="time" :label="$t('label_1045')" align="center">
										</el-table-column>
										<el-table-column prop="a" :label="$t('label_1046')" align="center">
										</el-table-column>
									</el-table-column>

									<el-table-column prop="content" :label="$t('label_751')" align="center">
										<el-table-column prop="cnum" :label="$t('label_291') + $t('label_1047')" align="center">
										</el-table-column>
										<el-table-column prop="cnum3" :label="$t('label_261') + $t('label_1047')" align="center">
											<template slot-scope="scope">
												<p :class="scope.row.cnum3>0?'louNum':''">{{scope.row.cnum3}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="cnum4" :label="$t('label_265') + $t('label_1047')" align="center">
											<template slot-scope="scope">
												<p :class="scope.row.cnum4>0?'louNum':''">{{scope.row.cnum4}}</p>
											</template>
										</el-table-column>
										<el-table-column prop=" cafnum" :label="$t('label_864') + $t('label_1047')" align="center">
											<template slot-scope="scope">
												<p :class="scope.row.cafnum>0?'louNum':''">{{scope.row.cafnum}}</p>
											</template>
										</el-table-column>
									</el-table-column>

									<el-table-column prop="content" :label="$t('label_88')" align="center">
										<el-table-column prop="mnum" :label="$t('label_390') + $t('label_1047')" align="center">
										</el-table-column>
										<el-table-column prop="mnum3" :label="$t('label_623') + $t('label_1047')" align="center">
											<template slot-scope="scope">
												<p :class="scope.row.mnum3>0?'louNum':''">{{scope.row.mnum3}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="mnum4" :label="$t('label_627') + $t('label_1047')" align="center">
											<template slot-scope="scope">
												<p :class="scope.row.mnum4>0?'louNum':''">{{scope.row.mnum4}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="mafnum" :label="$t('label_864') + $t('label_1047')" align="center">
											<template slot-scope="scope">
												<p :class="scope.row.mafnum>0?'louNum':''">{{scope.row.mafnum}}</p>
											</template>
										</el-table-column>
									</el-table-column>

									<el-table-column prop="content" :label="$t('label_291')" align="center">
										<el-table-column prop="inum"  :label="$t('label_291') + $t('label_1047')" align="center">
										</el-table-column>
										<el-table-column prop="inum3" :label="$t('label_261') + $t('label_1047')" align="center">
											<template slot-scope="scope">
												<p :class="scope.row.inum3>0?'louNum':''">{{scope.row.inum3}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="inum4" :label="$t('label_265') + $t('label_1047')" align="center">
											<template slot-scope="scope">
												<p :class="scope.row.inum4>0?'louNum':''">
													{{scope.row.inum4}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="iafnum" :label="$t('label_864') + $t('label_1047')" align="center">
											<template slot-scope="scope">
												<p :class="scope.row.iafnum>0?'louNum':''">{{scope.row.iafnum}}</p>
											</template>
										</el-table-column>
									</el-table-column>

								</el-table>

								<!-- 分页 -->
								<div style="position: absolute;bottom: 30px;left: 30%">
									<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
									 @parentMethod="searchPage"></Page>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 导出 -->
		<exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList"
		 ref="exportBox"></exportMes>

	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import calendar from "@/components/list/calendar/calendar";
	import tree from "@/components/list/tree/maintainTree";
	import file from "@/assets/js/file/file.js";
	import checkItem from "@/components/list/displayPage/checkItemParam";
	import maintenanceItem from "@/components/list/displayPage/maintenanceItemParam";
	import inspectionItem from "@/components/list/displayPage/inspectionItemParam";
	import electronDocument from "@/components/list/displayPage/electronDocumentParam";
	import partInfo from "@/components/list/displayPage/partInfoParam";
	import common from "@/assets/js/common/common.js";
	import statistics from "@/assets/js/statistics/statistics.js";
	import exportMes from "@/components/list/export/export";

	export default {
		name: 'causeStatistics',
		components: {
			Page,
			calendar,
			tree,
			checkItem,
			maintenanceItem,
			inspectionItem,
			electronDocument,
			partInfo,
			exportMes,
		},
		data() {
			return {
				exportList: [
				  {
					column: 'tname',
					title: '设备类型',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'name',
					title: '设备名称',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'code',
					title: '设备编号',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'superior',
					title: '设备所属区域',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'useTime',
					title: '运行时长(分)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},
    //     {
				// 	column: '',
				// 	title: '剩余寿命(分)',
				// 	headerAlign: 'center',
				// 	align: 'center',
				// 	width: '200px'
				// },
        {
					column: 'lifeTime',
					title: '寿命上线(分)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'num',
					title: '故障统计总次数(次)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'time',
					title: '故障统计总时长(分)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'a',
					title: '故障统计平均时长(分)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'cnum',
					title: '点检统计点检(次)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'cnum3',
					title: '点检统计漏检(次)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'cnum4',
					title: '点检统计补检(次)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'cafnum',
					title: '点检统计异常(次)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'mnum',
					title: '保养计划保养(次)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'mnum3',
					title: '保养计划逾期未保(次)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'mnum4',
					title: '保养计划逾期保养(次)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'mafnum',
					title: '保养计划异常(次)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'inum',
					title: '巡检统计点检(次)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'inum3',
					title: '巡检统计漏检(次)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'inum4',
					title: '巡检统计补检(次)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},{
					column: 'iafnum',
					title: '巡检统计异常(次)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				},

        ],
				tableDataTreeTimeExport: [],
				exportTitle: '设备综合统计',
				pageNum: 1,
				pageSize: 10,
				pageCount: 0,
				MenuRoleList: [],
				getTreeMes: '1',
				checked: false,
				newRisk: {
					content: '',
					dictContentKey: '',
				},
				deviceDetailMes: {},
				tableChooseInfo: {},
				dialogAdd: false,
				editName: this.$t('btn_14'),
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: false,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: false,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				tableDataList: [],
				parameterData: [],
				activeNameTree: 'first',
				riskID: '0',
				riskList: [],
				Readytime: '',
				code: '',
				status: '',
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		methods: {
			cellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				let cellStyle;
				switch (columnIndex) {
					case 0:
					case 2:
					case 4:
					case 5:
					case 7:
					case 8:
					case 9:
					case 11:
					case 12:
					case 13:
					case 15:
					case 16:
					case 17:
						cellStyle = 'border-right:1px solid #ebeef5';
						break;
					default:
						cellStyle = 'border-right:1px solid #000000';
				}
				return cellStyle;
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			exportClick() {
				this.$refs.exportBox.setExportExcel();
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			handleCurrentChangeTreeTime(info) {
				this.tableChooseInfo = info;
			},
			handleClickTree(tab, event) {
				this.getTreeMes = '1';
				this.deviceDetailMes = {};
				this.search({
					pageNum: 1,
					pageSize: this.pageSize,
				});
			},
			getDeviceMes(data) {
				if (data.name == this.$t('label_272')) {
					this.deviceDetailMes = {};
					this.search({
						pageNum: 1,
						pageSize: this.pageSize,
					});
				} else {
					this.deviceDetailMes = data;
					this.search({
						pageNum: 1,
						pageSize: this.pageSize,
					});

				}
			},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param);
			},
			searchPage(param) {
				var dataParam = {
					id: this.deviceDetailMes.id,
					type: this.deviceDetailMes.type,
					beginTime:this.Readytime[0]+' 00:00:00',
					endTime:this.Readytime[1]+' 23:59:59',
					name: this.code,
				};
				var newParam = Object.assign(param, dataParam);
				console.log(this.deviceDetailMes)
				console.log(newParam)
				statistics.comprehensive(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataList = data.data.records;
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.current;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
				statistics.comprehensiveExcel(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTimeExport = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getNowTime() {
				let zeroTime = new Date();
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
					1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			getBeforeTime() {
				var time = (new Date).getTime() + 24 * 60 * 60 * 1000;
				let zeroTime = new Date(time);
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
					1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			//初始化时间
			initDate(){
					var date = new Date();
					var seperator = "-";
					var year = date.getFullYear();
					var month = date.getMonth() + 1;
					var day = date.getDate();
			    //开始时间
					var beginTime = year + seperator + this.zero(month)+ seperator + '01';
			    //结束时间
			    var endTime = this.getday(year + seperator + this.zero(month)+ seperator + this.zero(day));
			    this.Readytime = [beginTime,endTime];
				console.log(this.Readytime)
			    this.search();
				},
				//补0
				zero(i){
					return i > 9 ? i : '0' + i;
				},
				//最后一天
				getday(val){
				var nextMonthFirstDay=new Date(val.substring(0,4),val.substring(5,7),1);
				var oneDay=1000*60*60*24;
				var lastTime = new Date(nextMonthFirstDay-oneDay);
				var day = lastTime.getDate();
				var month = parseInt(lastTime.getMonth()+1);
				if (month < 10) {
				month = '0' + month
				}
				if (day < 10) {
				day = '0' + day
				}
				return lastTime.getFullYear() + '-' + month + '-' + day+ ' ' ;
				},

		},
		created() {
			// this.Readytime = [this.getNowTime(), this.getBeforeTime()]
			this.MenuRoleList = this.$store.getters.getMenu;
			this.initDate();

		}
	}
</script>

<style scoped>
	.el-autocomplete {
		display: none;
	}

 element.style {
 }
 .buttonBox .chooseButton {
     display: inline-block;
     line-height: 1;
     white-space: nowrap;
     cursor: pointer;
     -webkit-appearance: none;
     text-align: center;
     -webkit-box-sizing: border-box;
     box-sizing: border-box;
     outline: 0;
     margin: 0;
     -webkit-transition: .1s;
     transition: .1s;
     font-weight: 500;
     padding: 10px 20px;
     font-size: 14px;
     border-radius: 4px;
     margin-left: 0px;
 }
</style>
<style>
  .tableBorderBlack .el-table--enable-row-transition .el-table__body td{
    border-bottom: 1px solid #000000;
  }
  .tableBorderBlack .el-table tr{
    border-left: 1px solid #000000;
  }
</style>



// WEBPACK FOOTER //
// src/pages/statisticalAnalysis/causeStatistics.vue